import { PalletDto } from 'src/store/pallets/pallet';
import { ArrayUtils } from 'src/utils/array';
import { PalletAction, PalletTypes } from './pallets.actions';

export type PalletsState = Readonly<{
  pallets: PalletDto[];
  errors: any;
}>;

const initialState: PalletsState = {
  pallets: [],
  errors: null
};

const palletsReducer = (
  state: PalletsState = initialState,
  action: PalletAction
) => {
  switch (action.type) {
    case PalletTypes.FetchAll:
      return { ...state, pallets: action.pallets };
    case PalletTypes.Add:
      return { ...state, pallets: [...state.pallets, action.pallet] };
    case PalletTypes.Update:
      return {
        ...state,
        pallets: ArrayUtils.updateListById(state.pallets, action.pallet)
      };
    case PalletTypes.Delete:
      return {
        ...state,
        pallet: null,
        pallets: ArrayUtils.deleteFromListById(state.pallets, action.pallet)
      };
    case PalletTypes.Failure:
      return { ...state, errors: action.errors };
    default:
      return state;
  }
};

export default palletsReducer;
